/**
 * Test IDs for QA automation.
 */
export const testIds = {
  userDetailsDelete: "user-details-delete",
  userDetailsToggleAccountStatus: "user-details-toggle-account-status",
  userDetailsEditUser: "user-details-edit-user",
  userDetailsOpenPasswordUpdate: "user-details-open-password-update",
  userDetailsPasswordLink: "user-details-password-link",
  userDetailsPasswordField: "user-details-password-field",
  userDetailsUpdate: "user-details-update",
} as const;
